import { call, takeLatest, put } from "redux-saga/effects";
import { fetchDashboardFilters, fetchDashboardFilterData, fetchDashboardOverview, fetchStudentCountBySchools, fetchSubmoduleStats, fetchSubmoduleDetails, fetchModuleStats } from "@store/actions/adminDashboardActions";
import { resourceService } from "@libs/axios";
import { setAdminDashboardData, setLoading, setAdminDashboardFilter, setDashboardOverviewData, setStudentCountBySchools, setSubmoduleStats, setSubmoduleDetails, setModuleStats, setExerciseChartsLoading, setSubmoduleDetailsChartsLoading, setDashboardFilter, setDashboardResponse, clearDashboardFilter, DashboardFilter, setDashboardClassResponse } from "@store/reducers/adminDashboardReducer";
import { AdminDashBoardFormatDate as formatDate } from '@utils/FormatDate';
import { ResponseType } from "@store/index";
import dayjs from 'dayjs'

const API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function* fetchDashboardFiltersSaga(action: ReturnType<typeof fetchDashboardFilters>) {
  try {
    yield put(setLoading(true))
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/admin_dashboard_api/', {
      params: { ...action.payload }
    })
    if (response.status === 200) {
      yield put(setAdminDashboardData(response.data))
      yield put(setLoading(false))
    }
  }
  catch (error) {
    console.error(error)
    yield put(setLoading(false))
  }
}

function* fetchDashboardFilterDataSaga(action: ReturnType<typeof fetchDashboardFilterData>) {
  try {
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/admin_dashboard_api_filter', {
      params: { ...action.payload }
    })
    if (response.status === 200) {
      yield put(setAdminDashboardFilter(response.data))
    }
  }
  catch (error) {
    console.error(error)
  }
}

function* fetchDashboardOverviewSaga() {
  try {
    yield put(setLoading(true));
    const response: ResponseType = yield call(resourceService.get, API_URL + '/api/dashboard_overview');
    if (response.status === 200) {
      yield put(setDashboardOverviewData(response.data));
    }
  }
  catch (error) {
    console.error(error);
  }
  finally {
    yield put(setLoading(false));
  }
}

function* fetchStudentCountBySchoolsSaga(action: ReturnType<typeof fetchStudentCountBySchools>) {
  try {
    yield put(setLoading(true));
    const startDate = action.payload.start_date
      ? formatDate(action.payload.start_date)
      : formatDate(oneMonthAgo);

    const endDate = action.payload.end_date
      ? formatDate(action.payload.end_date)
      : formatDate(today);
    const { province, district, ward, school_ids } = action.payload
    const response: ResponseType = yield call(
      resourceService.get,
      API_URL + '/api/dashboard_student_count_by_schools/',
      {
        params: {
          province,
          district,
          ward,
          start_date: startDate,
          end_date: endDate,
          school: action.payload.school_ids
        },
      },
    );
    if (response.status === 200) {
      yield put(setStudentCountBySchools(response.data));
    }
  }
  catch (error) {
    console.error(error);
  }
  finally {
    yield put(setLoading(false));
  }
}

// ==== Today and oneMonthAgo  ====
const today = new Date();
const oneMonthAgo = new Date();
oneMonthAgo.setMonth(today.getMonth() - 1);

// ==== fetchSubmoduleStatsSaga ====
function* fetchSubmoduleStatsSaga(action: ReturnType<typeof fetchSubmoduleStats>) {
  try {
    yield put(setExerciseChartsLoading(true))

    const startDate = action.payload.date_from
      ? formatDate(action.payload.date_from)
      : formatDate(oneMonthAgo);

    const endDate = action.payload.date_to
      ? formatDate(action.payload.date_to)
      : formatDate(today);

    const response: ResponseType = yield call(resourceService.get, `${REACT_APP_API_URL}/api/dashboard_class_submodule_stats/`, {
      params: {
        school_id: action.payload.school_ids,
        // class_id: action.payload.class_ids||null,
        start_date: startDate,
        end_date: endDate
      }
    });

    if (response.status === 200) {
      yield put(setSubmoduleStats(response.data));
    }
  } catch (error) {
    console.error('Error fetching submodule stats:', error);
    yield put(setSubmoduleStats(null));
  } finally {
    yield put(setExerciseChartsLoading(false));
  }
}


// ==== fetchSubmoduleDetailsSaga ====
function* fetchSubmoduleDetailsSaga(action: ReturnType<typeof fetchSubmoduleDetails>) {
  try {
    yield put(setSubmoduleDetailsChartsLoading(true));

    const startDate = action.payload.date_from
      ? formatDate(action.payload.date_from)
      : formatDate(oneMonthAgo);

    const endDate = action.payload.date_to
      ? formatDate(action.payload.date_to)
      : formatDate(today);

    const response: ResponseType = yield call(resourceService.get, `${REACT_APP_API_URL}/api/dashboard_class_submodule_stats_detail/`, {
      params: {
        class_id: action.payload.class_ids,
        start_date: startDate,
        end_date: endDate
      }
    });
    console.log("response submodule details", response)
    if (response.status === 200) {
      yield put(setSubmoduleDetails(response.data));
    }
  } catch (error) {
    console.error('Error fetching submodule details:', error);
    yield put(setSubmoduleDetails([]));
  } finally {
    yield put(setSubmoduleDetailsChartsLoading(false));
  }
}

// ==== fetchModuleStatsSaga ====
function* fetchModuleStatsSaga(action: ReturnType<typeof fetchModuleStats>) {
  try {
    yield put(setExerciseChartsLoading(true));

    const fromDate = action.payload.date_from
      ? formatDate(action.payload.date_from)
      : formatDate(oneMonthAgo);

    const toDate = action.payload.date_to
      ? formatDate(action.payload.date_to)
      : formatDate(today);

    const response: ResponseType = yield call(resourceService.get, `${REACT_APP_API_URL}/api/dashboard_class_module_stats/`, {
      params: {
        class_id: action.payload.class_ids,
        from_date: fromDate,
        to_date: toDate
      }
    });

    if (response.status === 200) {
      yield put(setModuleStats(response.data));
    }
  } catch (error) {
    console.error('Error fetching module stats:', error);
    yield put(setModuleStats(null));
  } finally {
    yield put(setExerciseChartsLoading(false));
  }
}


function* fetchDashboardDataSaga(action: ReturnType<typeof setDashboardFilter>) {
  try {
    const payload: DashboardFilter = action.payload
    yield put(setLoading(true));
    const responseOverview: ResponseType = yield call(resourceService.get, API_URL + '/api/dashboard_student_count_by_schools_v2', {
      params: {
        ...payload,
        start_date: payload?.start_date?.format("YYYY-MM-DD") || dayjs().subtract(30, 'days').format("YYYY-MM-DD"),
        end_date: payload?.end_date?.format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
      }
    });
    if (responseOverview.status === 200) {
      yield put(setDashboardResponse(responseOverview.data));
    }
    if (payload?.class_id) {
      const response: ResponseType = yield call(resourceService.get, `${REACT_APP_API_URL}/api/dashboard_class_submodule_stats_detail_v2/`, {
        params: {
          class_id: payload.class_id,
          start_date: payload?.start_date?.format("YYYY-MM-DD") || dayjs().subtract(30, 'days').format("YYYY-MM-DD"),
          end_date: payload?.end_date?.format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
        }
      });

      if (response.status === 200) {
        yield put(setDashboardClassResponse(response.data));
      }
      return
    }
    else if (payload?.school_id) {
      const response: ResponseType = yield call(resourceService.get, `${REACT_APP_API_URL}/api/dashboard_class_submodule_stats/`, {
        params: {
          school_id: payload?.school_id,
          start_date: payload?.start_date?.format("YYYY-MM-DD") || dayjs().subtract(30, 'days').format("YYYY-MM-DD"),
          end_date: payload?.end_date?.format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
        }
      });

      if (response.status === 200) {
        yield put(setSubmoduleStats(response.data));
      }
      return
    }
  }
  catch (error) {
    console.error(error);
  }
  finally {
    yield put(setLoading(false));
  }
}


function* adminDashboardSaga() {
  yield takeLatest(fetchDashboardFilters, fetchDashboardFiltersSaga)
  yield takeLatest(fetchDashboardFilterData, fetchDashboardFilterDataSaga)
  yield takeLatest(fetchDashboardOverview, fetchDashboardOverviewSaga)
  yield takeLatest(fetchStudentCountBySchools, fetchStudentCountBySchoolsSaga)
  yield takeLatest(fetchSubmoduleStats, fetchSubmoduleStatsSaga)
  yield takeLatest(fetchSubmoduleDetails, fetchSubmoduleDetailsSaga)
  yield takeLatest(fetchModuleStats, fetchModuleStatsSaga)
  yield takeLatest(setDashboardFilter.type, fetchDashboardDataSaga);
  yield takeLatest(clearDashboardFilter.type, fetchDashboardDataSaga);
}

export default adminDashboardSaga;